// System
import { useDispatch } from 'react-redux';
import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
// Redux
import { useRoundsTable } from '@Modal/hooks/rounds/useRoundsTable';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
// Graphql
import { useAviatorLiveRoundStatusQuery } from '@Src/generated.graphql';

export const RoundsTitle: React.FC = () => {
  const dispatch = useDispatch();
  const { currentUser } = useAuthorization();
  const { data } = useAviatorLiveRoundStatusQuery();
  const { roundTableFilters, clearRoundTableFiltersHandler, setShowRoundStatusModalDialog } =
    useRoundsTable();
  const objectVals = Object.values(roundTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="roundsListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Typography variant="h3">Rounds</Typography>
        <Stack direction="row" alignItems="center" gap={2}>
          {currentUser?.isSuper && (
            <AtLocator type="button" name="clearFilters">
              <Button
                size="large"
                variant="contained"
                onClick={() => dispatch(setShowRoundStatusModalDialog(true))}
              >
                status: {data?.aviatorLiveRoundStatus}
              </Button>
            </AtLocator>
          )}
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              disabled={disabled}
              onClick={clearRoundTableFiltersHandler}
            >
              Clear filters
            </Button>
          </AtLocator>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
